import script from "./scoreModal.vue?vue&type=script&setup=true&lang=js"
export * from "./scoreModal.vue?vue&type=script&setup=true&lang=js"

import "./scoreModal.vue?vue&type=style&index=0&id=12c9c2e8&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c9c2e8"]])

export default __exports__